import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-[#0a0e1a] relative overflow-hidden" data-id="element-28">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-[300px] bg-amber-900/20 blur-[100px] rounded-full pointer-events-none" data-id="element-29"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-30">
        <FadeIn data-id="element-31">
          <div className="text-center mb-16" data-id="element-32">
            <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-33">
              Tenés dos caminos hoy:
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-34">
          <FadeIn delay={100} data-id="element-35">
            <div className="bg-slate-900/50 border border-slate-800 p-8 rounded-3xl h-full opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-36">
              <div className="flex items-center gap-3 mb-6" data-id="element-37">
                <XCircle className="w-8 h-8 text-red-500" data-id="element-38" />
                <h3 className="text-2xl font-bold text-white" data-id="element-39">Camino A</h3>
              </div>
              <p className="text-slate-400 text-lg leading-relaxed" data-id="element-40">
                Seguir scroleando, irte a dormir tarde, despertarte cansado y
                ver cómo el estrés sigue afectando tu vida, tu humor y tu salud
                a largo plazo.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-41">
            <div className="bg-slate-800/80 border-2 border-amber-500/30 p-8 rounded-3xl h-full shadow-[0_0_30px_-10px_rgba(245,158,11,0.15)]" data-id="element-42">
              <div className="flex items-center gap-3 mb-6" data-id="element-43">
                <CheckCircle2 className="w-8 h-8 text-emerald-500" data-id="element-44" />
                <h3 className="text-2xl font-bold text-white" data-id="element-45">Camino B</h3>
              </div>
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-46">
                Invertir lo que cuestan{' '}
                <strong className="text-white" data-id="element-47">
                  dos combos de hamburguesa
                </strong>{' '}
                en un método comprobado que puede devolverte la paz y el sueño
                profundo para siempre.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={300} className="text-center" data-id="element-48">
          <CTAButton onClick={scrollToPricing} className="mb-6" data-id="element-49">
            SÍ, QUIERO EMPEZAR ESTA NOCHE
          </CTAButton>
          <p className="text-slate-400 text-sm" data-id="element-50">
            (Acceso inmediato al PDF y Audios después del pago)
          </p>
        </FadeIn>
      </div>
    </section>;
}